import React from "react";

import {BgHome} from "./BgHome";



function Home() {
    return (
            <>
            <BgHome/>
            </>
              );
}
export default Home;
